import './App.css';
import Navigation from './components/Navigation/Navigation';
import Main from './components/Main/Main';


const App = () => {  

  return (
    <div className="App">
      <Navigation/>
      <Main/>
    </div>
  )
}

export default App;